import * as React from "react";
import { LocationInfoContainer } from "../../../../containers/modules/LocationInfo/containers/LocationInfoContainer.js";
const LocationInfo = (props) => /* @__PURE__ */ React.createElement(LocationInfoContainer, { ...props });
export {
  LocationInfo
};
//# sourceMappingURL=LocationInfo.js.map
